module.exports = function (e) {
  var t = {};

  function o(r) {
    if (t[r]) return t[r].exports;
    var n = t[r] = {
      i: r,
      l: !1,
      exports: {}
    };
    return e[r].call(n.exports, n, n.exports, o), n.l = !0, n.exports;
  }

  return o.m = e, o.c = t, o.d = function (e, t, r) {
    o.o(e, t) || Object.defineProperty(e, t, {
      enumerable: !0,
      get: r
    });
  }, o.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, o.t = function (e, t) {
    if (1 & t && (e = o(e)), 8 & t) return e;
    if (4 & t && "object" == typeof e && e && e.__esModule) return e;
    var r = Object.create(null);
    if (o.r(r), Object.defineProperty(r, "default", {
      enumerable: !0,
      value: e
    }), 2 & t && "string" != typeof e) for (var n in e) {
      o.d(r, n, function (t) {
        return e[t];
      }.bind(null, n));
    }
    return r;
  }, o.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return o.d(t, "a", t), t;
  }, o.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, o.p = "", o(o.s = 12);
}([function (e, t) {
  e.exports = require("react");
}, function (e, t) {
  e.exports = require("classnames");
}, function (e, t, o) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.Avatar = void 0;

  var r = "/Users/burak/github/react-chat-elements/src/Avatar/Avatar.js",
      n = function () {
    function e(e, t) {
      for (var o = 0; o < t.length; o++) {
        var r = t[o];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    return function (t, o, r) {
      return o && e(t.prototype, o), r && e(t, r), t;
    };
  }(),
      a = o(0),
      i = function (e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }(a);

  o(48);

  var s = o(1),
      l = [],
      u = t.Avatar = function (e) {
    function t(e) {
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t);

      var o = function (e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e));

      return o.requestImage = o.requestImage.bind(o), o;
    }

    return function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }(t, a.Component), n(t, [{
      key: "componentDidMount",
      value: function value() {
        this._isMounted = !0;
      }
    }, {
      key: "componentWillUnmount",
      value: function value() {
        this._isMounted = !1;
      }
    }, {
      key: "isLoaded",
      value: function value(e) {
        return -1 !== l.indexOf(e);
      }
    }, {
      key: "requestImage",
      value: function value(e) {
        var t = this,
            o = this;
        this.loading = !0;

        var r = function r() {
          l.push(e), delete o.loading, !1 !== t._isMounted && o.setState({});
        },
            n = document.createElement("img");

        n.src = e, n.onload = r, n.onerror = r;
      }
    }, {
      key: "stringToColour",
      value: function value(e) {
        for (var t = 0, o = 0; o < e.length; o++) {
          t = e.charCodeAt(o) + ((t << 5) - t);
        }

        for (var r = "#", n = 0; n < 3; n++) {
          var a = t >> 8 * n & 255;
          r += ("00" + (a = a % 150 + 50).toString(16)).substr(-2);
        }

        return r;
      }
    }, {
      key: "render",
      value: function value() {
        var e = this.props.src,
            t = !1;
        return this.props.lazyLoadingImage && (t = !0, this.isLoaded(e) ? t = !1 : (e = this.props.lazyLoadingImage, this.loading || this.requestImage(this.props.src))), i.default.createElement("div", {
          className: s("rce-avatar-container", this.props.type, this.props.size, this.props.className),
          __source: {
            fileName: r,
            lineNumber: 79
          }
        }, this.props.letterItem ? i.default.createElement("div", {
          className: "rce-avatar-letter-background",
          style: {
            backgroundColor: this.stringToColour(this.props.letterItem.id)
          },
          __source: {
            fileName: r,
            lineNumber: 82
          }
        }, i.default.createElement("span", {
          class: "rce-avatar-letter",
          __source: {
            fileName: r,
            lineNumber: 85
          }
        }, this.props.letterItem.letter)) : i.default.createElement("img", {
          alt: this.props.alt,
          src: e,
          onError: this.props.onError,
          className: s("rce-avatar", {
            "rce-avatar-lazy": t
          }),
          __source: {
            fileName: r,
            lineNumber: 90
          }
        }), this.props.sideElement);
      }
    }]), t;
  }();

  u.defaultProps = {
    type: "default",
    size: "default",
    src: "",
    alt: "",
    sideElement: null,
    lazyLoadingImage: void 0,
    onError: function onError() {}
  }, t.default = u;
}, function (e, t, o) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.Button = void 0;

  var r = "/Users/burak/github/react-chat-elements/src/Button/Button.js",
      n = function () {
    function e(e, t) {
      for (var o = 0; o < t.length; o++) {
        var r = t[o];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    return function (t, o, r) {
      return o && e(t.prototype, o), r && e(t, r), t;
    };
  }(),
      a = o(0),
      i = function (e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }(a);

  o(58);

  var s = o(1),
      l = t.Button = function (e) {
    function t() {
      return function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t), function (e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
    }

    return function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }(t, a.Component), n(t, [{
      key: "render",
      value: function value() {
        return i.default.createElement("button", {
          ref: this.props.buttonRef,
          title: this.props.title,
          className: s("rce-button", this.props.type, this.props.className),
          style: {
            backgroundColor: this.props.backgroundColor,
            color: this.props.color,
            borderColor: this.props.backgroundColor
          },
          disabled: this.props.disabled,
          onClick: this.props.onClick,
          __source: {
            fileName: r,
            lineNumber: 9
          }
        }, this.props.icon ? i.default.createElement("span", {
          className: "rce-button-icon--container",
          __source: {
            fileName: r,
            lineNumber: 22
          }
        }, ("right" === this.props.icon.float || !this.props.icon.float) && i.default.createElement("span", {
          __source: {
            fileName: r,
            lineNumber: 23
          }
        }, this.props.text), i.default.createElement("span", {
          style: {
            float: this.props.icon.float,
            fontSize: this.props.icon.size || 12
          },
          className: "rce-button-icon",
          __source: {
            fileName: r,
            lineNumber: 25
          }
        }, this.props.icon.component), "left" === this.props.icon.float && i.default.createElement("span", {
          __source: {
            fileName: r,
            lineNumber: 27
          }
        }, this.props.text)) : i.default.createElement("span", {
          __source: {
            fileName: r,
            lineNumber: 29
          }
        }, this.props.text));
      }
    }]), t;
  }();

  l.defaultProps = {
    text: "",
    disabled: !1,
    type: null,
    icon: null,
    backgroundColor: "#3979aa",
    color: "white",
    className: null,
    buttonRef: null,
    title: null
  }, t.default = l;
}, function (e, t, o) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.MessageBox = void 0;

  var r = "/Users/burak/github/react-chat-elements/src/MessageBox/MessageBox.js",
      n = function () {
    function e(e, t) {
      for (var o = 0; o < t.length; o++) {
        var r = t[o];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    return function (t, o, r) {
      return o && e(t.prototype, o), r && e(t, r), t;
    };
  }(),
      a = o(0),
      i = g(a);

  o(31);

  var s = g(o(13)),
      l = g(o(14)),
      u = g(o(8)),
      c = g(o(16)),
      p = g(o(17)),
      f = g(o(9)),
      m = g(o(2)),
      h = g(o(18)),
      d = g(o(19)),
      b = g(o(20)),
      _ = g(o(21)),
      y = g(o(22)),
      N = o(10),
      v = g(o(1));

  function g(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  var w = t.MessageBox = function (e) {
    function t() {
      return function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t), function (e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
    }

    return function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }(t, a.Component), n(t, [{
      key: "componentWillReceiveProps",
      value: function value(e) {
        e.focus !== this.props.focus && !0 === e.focus && this.refs.message && (this.refs.message.scrollIntoView({
          block: "center",
          behavior: "smooth"
        }), this.props.onMessageFocused(e));
      }
    }, {
      key: "render",
      value: function value() {
        var e = (0, v.default)("rce-mbox", {
          "rce-mbox-right": "right" === this.props.position
        }),
            t = "text" !== this.props.type && "file" !== this.props.type && !("location" === this.props.type && this.props.text),
            o = this.props.date && !isNaN(this.props.date) && (this.props.dateString || (0, N.format)(this.props.date));
        return i.default.createElement("div", {
          ref: "message",
          className: (0, v.default)("rce-container-mbox", this.props.className),
          onClick: this.props.onClick,
          __source: {
            fileName: r,
            lineNumber: 51
          }
        }, this.props.renderAddCmp instanceof Function && this.props.renderAddCmp(), "system" === this.props.type ? i.default.createElement(u.default, {
          text: this.props.text,
          __source: {
            fileName: r,
            lineNumber: 61
          }
        }) : i.default.createElement("div", {
          className: (0, v.default)(e, {
            "rce-mbox--clear-padding": t
          }, {
            "rce-mbox--clear-notch": !this.props.notch
          }, {
            "message-focus": this.props.focus
          }),
          __source: {
            fileName: r,
            lineNumber: 64
          }
        }, i.default.createElement("div", {
          className: "rce-mbox-body",
          onContextMenu: this.props.onContextMenu,
          __source: {
            fileName: r,
            lineNumber: 71
          }
        }, !0 === this.props.forwarded && i.default.createElement("div", {
          className: (0, v.default)("rce-mbox-forward", {
            "rce-mbox-forward-right": "left" === this.props.position
          }, {
            "rce-mbox-forward-left": "right" === this.props.position
          }),
          onClick: this.props.onForwardClick,
          __source: {
            fileName: r,
            lineNumber: 76
          }
        }, i.default.createElement(h.default, {
          __source: {
            fileName: r,
            lineNumber: 83
          }
        })), !0 === this.props.replyButton && i.default.createElement("div", {
          className: !0 !== this.props.forwarded ? (0, v.default)("rce-mbox-forward", {
            "rce-mbox-forward-right": "left" === this.props.position
          }, {
            "rce-mbox-forward-left": "right" === this.props.position
          }) : (0, v.default)("rce-mbox-forward", {
            "rce-mbox-reply-btn-right": "left" === this.props.position
          }, {
            "rce-mbox-reply-btn-left": "right" === this.props.position
          }),
          onClick: this.props.onReplyClick,
          __source: {
            fileName: r,
            lineNumber: 89
          }
        }, i.default.createElement(y.default, {
          __source: {
            fileName: r,
            lineNumber: 100
          }
        })), (this.props.title || this.props.avatar) && i.default.createElement("div", {
          style: this.props.titleColor && {
            color: this.props.titleColor
          },
          onClick: this.props.onTitleClick,
          className: (0, v.default)("rce-mbox-title", {
            "rce-mbox-title--clear": "text" === this.props.type
          }),
          __source: {
            fileName: r,
            lineNumber: 106
          }
        }, this.props.avatar && i.default.createElement(m.default, {
          letterItem: this.props.letterItem,
          src: this.props.avatar,
          __source: {
            fileName: r,
            lineNumber: 114
          }
        }), this.props.title && i.default.createElement("span", {
          __source: {
            fileName: r,
            lineNumber: 120
          }
        }, this.props.title)), this.props.reply && i.default.createElement(f.default, {
          photoURL: this.props.reply.photoURL,
          title: this.props.reply.title,
          titleColor: this.props.reply.titleColor,
          message: this.props.reply.message,
          onClick: this.props.onReplyMessageClick,
          __source: {
            fileName: r,
            lineNumber: 127
          }
        }), "text" === this.props.type && i.default.createElement("div", {
          className: "rce-mbox-text",
          __source: {
            fileName: r,
            lineNumber: 137
          }
        }, this.props.text), "location" === this.props.type && i.default.createElement(c.default, {
          onOpen: this.props.onOpen,
          data: this.props.data,
          target: this.props.target,
          href: this.props.href,
          apiKey: this.props.apiKey,
          src: this.props.src,
          zoom: this.props.zoom,
          markerColor: this.props.markerColor,
          text: this.props.text,
          __source: {
            fileName: r,
            lineNumber: 144
          }
        }), "photo" === this.props.type && i.default.createElement(s.default, {
          onOpen: this.props.onOpen,
          onDownload: this.props.onDownload,
          onLoad: this.props.onLoad,
          onPhotoError: this.props.onPhotoError,
          data: this.props.data,
          width: this.props.width,
          height: this.props.height,
          text: this.props.text,
          __source: {
            fileName: r,
            lineNumber: 158
          }
        }), "file" === this.props.type && i.default.createElement(l.default, {
          onOpen: this.props.onOpen,
          onDownload: this.props.onDownload,
          data: this.props.data,
          text: this.props.text,
          __source: {
            fileName: r,
            lineNumber: 171
          }
        }), "spotify" === this.props.type && i.default.createElement(p.default, {
          width: this.props.width,
          height: this.props.height,
          theme: this.props.theme,
          view: this.props.view,
          data: this.props.data,
          uri: this.props.uri || this.props.text,
          __source: {
            fileName: r,
            lineNumber: 180
          }
        }), i.default.createElement("div", {
          className: (0, v.default)("rce-mbox-time", {
            "rce-mbox-time-block": t
          }, {
            "non-copiable": !this.props.copiableDate
          }),
          "data-text": this.props.copiableDate ? void 0 : o,
          __source: {
            fileName: r,
            lineNumber: 189
          }
        }, this.props.copiableDate && this.props.date && !isNaN(this.props.date) && (this.props.dateString || (0, N.format)(this.props.date)), this.props.status && i.default.createElement("span", {
          className: "rce-mbox-status",
          __source: {
            fileName: r,
            lineNumber: 207
          }
        }, "waiting" === this.props.status && i.default.createElement(b.default, {
          __source: {
            fileName: r,
            lineNumber: 210
          }
        }), "sent" === this.props.status && i.default.createElement(_.default, {
          __source: {
            fileName: r,
            lineNumber: 215
          }
        }), "received" === this.props.status && i.default.createElement(d.default, {
          __source: {
            fileName: r,
            lineNumber: 220
          }
        }), "read" === this.props.status && i.default.createElement(d.default, {
          color: "#4FC3F7",
          __source: {
            fileName: r,
            lineNumber: 225
          }
        })))), this.props.notch && ("right" === this.props.position ? i.default.createElement("svg", {
          className: (0, v.default)("rce-mbox-right-notch", {
            "message-focus": this.props.focus
          }),
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 20 20",
          __source: {
            fileName: r,
            lineNumber: 235
          }
        }, i.default.createElement("path", {
          d: "M0 0v20L20 0",
          __source: {
            fileName: r,
            lineNumber: 239
          }
        })) : i.default.createElement("div", {
          __source: {
            fileName: r,
            lineNumber: 242
          }
        }, i.default.createElement("svg", {
          className: (0, v.default)("rce-mbox-left-notch", {
            "message-focus": this.props.focus
          }),
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 20 20",
          __source: {
            fileName: r,
            lineNumber: 243
          }
        }, i.default.createElement("defs", {
          __source: {
            fileName: r,
            lineNumber: 247
          }
        }, i.default.createElement("filter", {
          id: "filter1",
          x: "0",
          y: "0",
          __source: {
            fileName: r,
            lineNumber: 248
          }
        }, i.default.createElement("feOffset", {
          result: "offOut",
          in: "SourceAlpha",
          dx: "-2",
          dy: "-5",
          __source: {
            fileName: r,
            lineNumber: 249
          }
        }), i.default.createElement("feGaussianBlur", {
          result: "blurOut",
          in: "offOut",
          stdDeviation: "3",
          __source: {
            fileName: r,
            lineNumber: 250
          }
        }), i.default.createElement("feBlend", {
          in: "SourceGraphic",
          in2: "blurOut",
          mode: "normal",
          __source: {
            fileName: r,
            lineNumber: 251
          }
        }))), i.default.createElement("path", {
          d: "M20 0v20L0 0",
          filter: "url(#filter1)",
          __source: {
            fileName: r,
            lineNumber: 254
          }
        }))))));
      }
    }]), t;
  }();

  w.defaultProps = {
    position: "left",
    type: "text",
    text: "",
    title: null,
    titleColor: null,
    onTitleClick: null,
    onForwardClick: null,
    onReplyClick: null,
    onReplyMessageClick: null,
    date: new Date(),
    data: {},
    onClick: null,
    onOpen: null,
    onDownload: null,
    onLoad: null,
    onPhotoError: null,
    forwarded: !1,
    reply: !1,
    status: null,
    dateString: null,
    notch: !0,
    avatar: null,
    renderAddCmp: null,
    copiableDate: !1,
    onContextMenu: null,
    focus: !1,
    onMessageFocused: null
  }, t.default = w;
}, function (e, t) {
  e.exports = require("react-icons/lib/fa/cloud-download");
}, function (e, t) {
  e.exports = require("react-icons/lib/fa/exclamation-triangle");
}, function (e, t) {
  e.exports = require("react-progress-bar.js");
}, function (e, t, o) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.SystemMessage = void 0;

  var r = "/Users/burak/github/react-chat-elements/src/SystemMessage/SystemMessage.js",
      n = function () {
    function e(e, t) {
      for (var o = 0; o < t.length; o++) {
        var r = t[o];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    return function (t, o, r) {
      return o && e(t.prototype, o), r && e(t, r), t;
    };
  }(),
      a = o(0),
      i = function (e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }(a);

  o(40);

  var s = o(1),
      l = t.SystemMessage = function (e) {
    function t() {
      return function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t), function (e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
    }

    return function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }(t, a.Component), n(t, [{
      key: "render",
      value: function value() {
        return i.default.createElement("div", {
          className: s("rce-container-smsg", this.props.className),
          __source: {
            fileName: r,
            lineNumber: 9
          }
        }, i.default.createElement("div", {
          className: "rce-smsg",
          __source: {
            fileName: r,
            lineNumber: 10
          }
        }, i.default.createElement("div", {
          className: "rce-smsg-text",
          __source: {
            fileName: r,
            lineNumber: 12
          }
        }, this.props.text)));
      }
    }]), t;
  }();

  t.default = l;
}, function (e, t, o) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.ReplyMessage = void 0;

  var r = "/Users/burak/github/react-chat-elements/src/ReplyMessage/ReplyMessage.js",
      n = function () {
    function e(e, t) {
      for (var o = 0; o < t.length; o++) {
        var r = t[o];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    return function (t, o, r) {
      return o && e(t.prototype, o), r && e(t, r), t;
    };
  }(),
      a = o(0),
      i = function (e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }(a);

  o(46);

  var s = o(1),
      l = t.ReplyMessage = function (e) {
    function t(e) {
      return function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t), function (e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e));
    }

    return function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }(t, a.Component), n(t, [{
      key: "render",
      value: function value() {
        var e = this.props,
            t = e.photoURL,
            o = e.title,
            n = e.titleColor,
            a = e.message,
            l = e.onClick;
        return i.default.createElement("div", {
          className: s("rce-mbox-reply", {
            "rce-mbox-reply-border": !!n
          }),
          style: n && {
            borderColor: n
          },
          onClick: l,
          __source: {
            fileName: r,
            lineNumber: 21
          }
        }, i.default.createElement("div", {
          className: "rce-mbox-reply-left",
          __source: {
            fileName: r,
            lineNumber: 27
          }
        }, i.default.createElement("div", {
          style: n && {
            color: n
          },
          className: "rce-mbox-reply-owner",
          __source: {
            fileName: r,
            lineNumber: 28
          }
        }, o || "Unknown"), i.default.createElement("div", {
          className: "rce-mbox-reply-message",
          __source: {
            fileName: r,
            lineNumber: 33
          }
        }, a || "...")), t && i.default.createElement("div", {
          className: "rce-mbox-reply-right",
          __source: {
            fileName: r,
            lineNumber: 39
          }
        }, i.default.createElement("img", {
          src: t,
          alt: "",
          __source: {
            fileName: r,
            lineNumber: 40
          }
        })));
      }
    }]), t;
  }();

  l.defaultProps = {
    photoURL: null,
    title: null,
    titleColor: null,
    message: null,
    onClick: function onClick() {}
  }, t.default = l;
}, function (e, t) {
  e.exports = require("timeago.js");
}, function (e, t, o) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.ChatItem = void 0;

  var r = "/Users/burak/github/react-chat-elements/src/ChatItem/ChatItem.js",
      n = function () {
    function e(e, t) {
      for (var o = 0; o < t.length; o++) {
        var r = t[o];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    return function (t, o, r) {
      return o && e(t.prototype, o), r && e(t, r), t;
    };
  }(),
      a = o(0),
      i = c(a);

  o(50);
  var s = c(o(2)),
      l = o(10),
      u = c(o(1));

  function c(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  var p = t.ChatItem = function (e) {
    function t() {
      return function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t), function (e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
    }

    return function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }(t, a.Component), n(t, [{
      key: "render",
      value: function value() {
        var e = this.props.statusColorType;
        return i.default.createElement("div", {
          className: (0, u.default)("rce-container-citem", this.props.className),
          onClick: this.props.onClick,
          onContextMenu: this.props.onContextMenu,
          __source: {
            fileName: r,
            lineNumber: 18
          }
        }, i.default.createElement("div", {
          className: "rce-citem",
          __source: {
            fileName: r,
            lineNumber: 22
          }
        }, i.default.createElement("div", {
          className: (0, u.default)("rce-citem-avatar", {
            "rce-citem-status-encircle": "encircle" === e
          }),
          __source: {
            fileName: r,
            lineNumber: 23
          }
        }, i.default.createElement(s.default, {
          src: this.props.avatar,
          alt: this.props.alt,
          className: "encircle" === e ? "rce-citem-avatar-encircle-status" : "",
          size: "large",
          letterItem: this.props.letterItem,
          sideElement: this.props.statusColor && i.default.createElement("span", {
            className: "rce-citem-status",
            style: "encircle" === e ? {
              boxShadow: "inset 0 0 0 2px " + this.props.statusColor + ", inset 0 0 0 5px #FFFFFF"
            } : {
              backgroundColor: this.props.statusColor
            },
            __source: {
              fileName: r,
              lineNumber: 37
            }
          }, this.props.statusText),
          onError: this.props.onAvatarError,
          lazyLoadingImage: this.props.lazyLoadingImage,
          type: (0, u.default)("circle", {
            flexible: this.props.avatarFlexible
          }),
          __source: {
            fileName: r,
            lineNumber: 29
          }
        })), i.default.createElement("div", {
          className: "rce-citem-body",
          __source: {
            fileName: r,
            lineNumber: 52
          }
        }, i.default.createElement("div", {
          className: "rce-citem-body--top",
          __source: {
            fileName: r,
            lineNumber: 53
          }
        }, i.default.createElement("div", {
          className: "rce-citem-body--top-title",
          __source: {
            fileName: r,
            lineNumber: 54
          }
        }, this.props.title), i.default.createElement("div", {
          className: "rce-citem-body--top-time",
          __source: {
            fileName: r,
            lineNumber: 57
          }
        }, this.props.date && !isNaN(this.props.date) && (this.props.dateString || (0, l.format)(this.props.date)))), i.default.createElement("div", {
          className: "rce-citem-body--bottom",
          __source: {
            fileName: r,
            lineNumber: 69
          }
        }, i.default.createElement("div", {
          className: "rce-citem-body--bottom-title",
          __source: {
            fileName: r,
            lineNumber: 70
          }
        }, this.props.subtitle), i.default.createElement("div", {
          className: "rce-citem-body--bottom-status",
          __source: {
            fileName: r,
            lineNumber: 73
          }
        }, this.props.unread > 0 && i.default.createElement("span", {
          __source: {
            fileName: r,
            lineNumber: 76
          }
        }, this.props.unread))))));
      }
    }]), t;
  }();

  p.defaultProps = {
    id: "",
    onClick: null,
    avatar: "",
    avatarFlexible: !1,
    alt: "",
    title: "",
    subtitle: "",
    date: new Date(),
    unread: 0,
    statusColor: null,
    statusColorType: "badge",
    statusText: null,
    dateString: null,
    lazyLoadingImage: void 0,
    onAvatarError: function onAvatarError() {}
  }, t.default = p;
}, function (e, t, o) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.ReplyMessage = t.Popup = t.SideBar = t.Dropdown = t.Navbar = t.Avatar = t.Button = t.Input = t.MessageList = t.ChatList = t.SystemMessage = t.ChatItem = t.MessageBox = void 0;
  var r = b(o(4)),
      n = b(o(11)),
      a = b(o(8)),
      i = b(o(23)),
      s = b(o(24)),
      l = b(o(26)),
      u = b(o(3)),
      c = b(o(2)),
      p = b(o(27)),
      f = b(o(28)),
      m = b(o(29)),
      h = b(o(30)),
      d = b(o(9));

  function b(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  t.MessageBox = r.default, t.ChatItem = n.default, t.SystemMessage = a.default, t.ChatList = i.default, t.MessageList = s.default, t.Input = l.default, t.Button = u.default, t.Avatar = c.default, t.Navbar = p.default, t.Dropdown = f.default, t.SideBar = m.default, t.Popup = h.default, t.ReplyMessage = d.default;
}, function (e, t, o) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.PhotoMessage = void 0;

  var r = "/Users/burak/github/react-chat-elements/src/PhotoMessage/PhotoMessage.js",
      n = function () {
    function e(e, t) {
      for (var o = 0; o < t.length; o++) {
        var r = t[o];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    return function (t, o, r) {
      return o && e(t.prototype, o), r && e(t, r), t;
    };
  }(),
      a = o(0),
      i = u(a);

  o(36);
  var s = u(o(5)),
      l = u(o(6));

  function u(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  var c = o(7).Circle,
      p = t.PhotoMessage = function (e) {
    function t() {
      return function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t), function (e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
    }

    return function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }(t, a.Component), n(t, [{
      key: "render",
      value: function value() {
        var e = {
          strokeWidth: 2.3,
          color: "#efe",
          trailColor: "#aaa",
          trailWidth: 1,
          step: function step(e, t) {
            t.path.setAttribute("trail", e.color), t.path.setAttribute("trailwidth-width", e.width);
            var o = Math.round(100 * t.value());
            0 === o ? t.setText("") : t.setText(o);
          }
        },
            t = this.props.data.status && !0 === this.props.data.status.error;
        return i.default.createElement("div", {
          className: "rce-mbox-photo",
          __source: {
            fileName: r,
            lineNumber: 33
          }
        }, i.default.createElement("div", {
          className: "rce-mbox-photo--img",
          style: this.props.data.width && this.props.data.height && {
            width: this.props.data.width,
            height: this.props.data.height
          },
          __source: {
            fileName: r,
            lineNumber: 34
          }
        }, i.default.createElement("img", {
          src: this.props.data.uri,
          alt: this.props.data.alt,
          onClick: this.props.onOpen,
          onLoad: this.props.onLoad,
          onError: this.props.onPhotoError,
          __source: {
            fileName: r,
            lineNumber: 40
          }
        }), t && i.default.createElement("div", {
          className: "rce-mbox-photo--img__block",
          __source: {
            fileName: r,
            lineNumber: 48
          }
        }, i.default.createElement("span", {
          className: "rce-mbox-photo--img__block-item rce-mbox-photo--error",
          __source: {
            fileName: r,
            lineNumber: 49
          }
        }, i.default.createElement(l.default, {
          __source: {
            fileName: r,
            lineNumber: 51
          }
        }))), !t && this.props.data.status && !this.props.data.status.download && i.default.createElement("div", {
          className: "rce-mbox-photo--img__block",
          __source: {
            fileName: r,
            lineNumber: 59
          }
        }, !this.props.data.status.click && i.default.createElement("button", {
          onClick: this.props.onDownload,
          className: "rce-mbox-photo--img__block-item rce-mbox-photo--download",
          __source: {
            fileName: r,
            lineNumber: 62
          }
        }, i.default.createElement(s.default, {
          __source: {
            fileName: r,
            lineNumber: 65
          }
        })), "number" == typeof this.props.data.status.loading && 0 !== this.props.data.status.loading && i.default.createElement(c, {
          progress: this.props.data.status.loading,
          options: e,
          initialAnimate: !0,
          containerClassName: "rce-mbox-photo--img__block-item",
          __source: {
            fileName: r,
            lineNumber: 71
          }
        }))), this.props.text && i.default.createElement("div", {
          className: "rce-mbox-text",
          __source: {
            fileName: r,
            lineNumber: 82
          }
        }, this.props.text));
      }
    }]), t;
  }();

  p.defaultProps = {
    text: "",
    data: {},
    onDownload: null,
    onOpen: null,
    onLoad: null,
    onPhotoError: null
  }, t.default = p;
}, function (e, t, o) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.FileMessage = void 0;

  var r = "/Users/burak/github/react-chat-elements/src/FileMessage/FileMessage.js",
      n = function () {
    function e(e, t) {
      for (var o = 0; o < t.length; o++) {
        var r = t[o];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    return function (t, o, r) {
      return o && e(t.prototype, o), r && e(t, r), t;
    };
  }(),
      a = o(0),
      i = c(a);

  o(38);
  var s = c(o(5)),
      l = c(o(6)),
      u = c(o(15));

  function c(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  var p = o(7).Circle,
      f = t.FileMessage = function (e) {
    function t() {
      return function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t), function (e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
    }

    return function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }(t, a.Component), n(t, [{
      key: "onClick",
      value: function value(e) {
        this.props.data.status && (!this.props.data.status.download && this.props.onDownload instanceof Function ? this.props.onDownload(e) : this.props.data.status.download && this.props.onOpen instanceof Function && this.props.onOpen(e));
      }
    }, {
      key: "render",
      value: function value() {
        var e = {
          strokeWidth: 5,
          color: "#333",
          trailColor: "#aaa",
          trailWidth: 5,
          step: function step(e, t) {
            t.path.setAttribute("trail", e.color), t.path.setAttribute("trailwidth-width", e.width);
            var o = Math.round(100 * t.value());
            0 === o ? t.setText("") : t.setText(o);
          }
        },
            t = this.props.data.status && !0 === this.props.data.status.error;
        return i.default.createElement("div", {
          className: "rce-mbox-file",
          __source: {
            fileName: r,
            lineNumber: 44
          }
        }, i.default.createElement("button", {
          onClick: this.onClick.bind(this),
          __source: {
            fileName: r,
            lineNumber: 45
          }
        }, i.default.createElement("div", {
          className: "rce-mbox-file--icon",
          __source: {
            fileName: r,
            lineNumber: 46
          }
        }, i.default.createElement(u.default, {
          color: "#aaa",
          __source: {
            fileName: r,
            lineNumber: 47
          }
        }), i.default.createElement("div", {
          className: "rce-mbox-file--size",
          __source: {
            fileName: r,
            lineNumber: 49
          }
        }, this.props.data.size)), i.default.createElement("div", {
          className: "rce-mbox-file--text",
          __source: {
            fileName: r,
            lineNumber: 53
          }
        }, this.props.text), i.default.createElement("div", {
          className: "rce-mbox-file--buttons",
          __source: {
            fileName: r,
            lineNumber: 56
          }
        }, t && i.default.createElement("span", {
          className: "rce-error-button",
          __source: {
            fileName: r,
            lineNumber: 59
          }
        }, i.default.createElement(l.default, {
          color: "#ff3d3d",
          __source: {
            fileName: r,
            lineNumber: 60
          }
        })), !t && this.props.data.status && !this.props.data.status.download && !this.props.data.status.click && i.default.createElement(s.default, {
          color: "#aaa",
          __source: {
            fileName: r,
            lineNumber: 69
          }
        }), !t && this.props.data.status && "number" == typeof this.props.data.status.loading && 0 !== this.props.data.status.loading && i.default.createElement(p, {
          progress: this.props.data.status.loading,
          options: e,
          initialAnimate: !0,
          containerClassName: "rce-mbox-file--loading",
          __source: {
            fileName: r,
            lineNumber: 77
          }
        }))));
      }
    }]), t;
  }();

  f.defaultProps = {
    text: "",
    data: {},
    onClick: null,
    onDownload: null,
    onOpen: null
  }, t.default = f;
}, function (e, t) {
  e.exports = require("react-icons/lib/fa/file");
}, function (e, t, o) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.LocationMessage = void 0;

  var r = "/Users/burak/github/react-chat-elements/src/LocationMessage/LocationMessage.js",
      n = function () {
    function e(e, t) {
      for (var o = 0; o < t.length; o++) {
        var r = t[o];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    return function (t, o, r) {
      return o && e(t.prototype, o), r && e(t, r), t;
    };
  }(),
      a = o(0),
      i = function (e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }(a);

  o(42);

  var s = o(1),
      l = t.LocationMessage = function (e) {
    function t(e) {
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t);

      var o = function (e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e));

      return o.className = o.className.bind(o), o;
    }

    return function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }(t, a.Component), n(t, [{
      key: "buildURL",
      value: function value(e) {
        var t = this.props.data || {};
        return e.replace(/LATITUDE/g, t.latitude).replace(/LONGITUDE/g, t.longitude).replace("MARKER_COLOR", this.props.markerColor).replace("ZOOM", this.props.zoom).replace("KEY", this.props.apiKey);
      }
    }, {
      key: "className",
      value: function value() {
        var e = s("rce-mbox-location", this.props.className);
        return this.props.text && (e = s(e, "rce-mbox-location-has-text")), e;
      }
    }, {
      key: "render",
      value: function value() {
        var e = this.props.data || {};
        return i.default.createElement("div", {
          className: "rce-container-lmsg",
          __source: {
            fileName: r,
            lineNumber: 40
          }
        }, i.default.createElement("a", {
          onClick: this.props.onOpen,
          target: this.props.target,
          href: this.props.href || this.props.src || this.buildURL(e.mapURL || "https://www.google.com/maps/search/?api=1&query=LATITUDE,LONGITUDE&zoom=ZOOM"),
          className: this.className(),
          __source: {
            fileName: r,
            lineNumber: 41
          }
        }, i.default.createElement("img", {
          onError: this.props.onError,
          className: "rce-mbox-location-img",
          src: this.props.src || this.buildURL(e.staticURL || "https://maps.googleapis.com/maps/api/staticmap?markers=color:MARKER_COLOR|LATITUDE,LONGITUDE&zoom=ZOOM&size=270x200&scale=2&key=KEY"),
          __source: {
            fileName: r,
            lineNumber: 46
          }
        })), this.props.text && i.default.createElement("div", {
          className: "rce-mbox-text rce-mbox-location-text",
          __source: {
            fileName: r,
            lineNumber: 56
          }
        }, this.props.text));
      }
    }]), t;
  }();

  l.defaultProps = {
    target: "_blank",
    apiKey: "",
    zoom: 14,
    markerColor: "red",
    onError: function onError() {}
  }, t.default = l;
}, function (e, t, o) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.SpotifyMessage = void 0;

  var r = "/Users/burak/github/react-chat-elements/src/SpotifyMessage/SpotifyMessage.js",
      n = function () {
    function e(e, t) {
      for (var o = 0; o < t.length; o++) {
        var r = t[o];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    return function (t, o, r) {
      return o && e(t.prototype, o), r && e(t, r), t;
    };
  }(),
      a = o(0),
      i = function (e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }(a);

  o(44);
  o(1);

  var s = t.SpotifyMessage = function (e) {
    function t() {
      return function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t), function (e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
    }

    return function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }(t, a.Component), n(t, [{
      key: "toUrl",
      value: function value() {
        var e = [],
            t = {
          uri: this.props.uri,
          theme: this.props.theme,
          view: this.props.view
        };

        for (var o in t) {
          var r = encodeURIComponent(o),
              n = encodeURIComponent(t[o]);
          e.push(r + "=" + n);
        }

        return e = e.join("&");
      }
    }, {
      key: "render",
      value: function value() {
        return this.props.uri ? i.default.createElement("div", {
          className: "rce-mbox-spotify",
          __source: {
            fileName: r,
            lineNumber: 27
          }
        }, i.default.createElement("iframe", {
          src: "https://open.spotify.com/embed?" + this.toUrl(),
          width: this.props.width,
          height: this.props.height,
          frameBorder: "0",
          allowtransparency: "true",
          __source: {
            fileName: r,
            lineNumber: 28
          }
        })) : null;
      }
    }]), t;
  }();

  s.defaultProps = {
    uri: "",
    theme: "black",
    view: "list",
    width: 300,
    height: 380
  }, t.default = s;
}, function (e, t) {
  e.exports = require("react-icons/lib/fa/mail-forward");
}, function (e, t) {
  e.exports = require("react-icons/lib/io/android-done-all");
}, function (e, t) {
  e.exports = require("react-icons/lib/md/access-time");
}, function (e, t) {
  e.exports = require("react-icons/lib/md/check");
}, function (e, t) {
  e.exports = require("react-icons/lib/md/message");
}, function (e, t, o) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.ChatList = void 0;

  var r = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var o = arguments[t];

      for (var r in o) {
        Object.prototype.hasOwnProperty.call(o, r) && (e[r] = o[r]);
      }
    }

    return e;
  },
      n = "/Users/burak/github/react-chat-elements/src/ChatList/ChatList.js",
      a = function () {
    function e(e, t) {
      for (var o = 0; o < t.length; o++) {
        var r = t[o];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    return function (t, o, r) {
      return o && e(t.prototype, o), r && e(t, r), t;
    };
  }(),
      i = o(0),
      s = u(i);

  o(52);
  var l = u(o(11));

  function u(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  var c = o(1),
      p = t.ChatList = function (e) {
    function t() {
      return function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t), function (e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
    }

    return function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }(t, i.Component), a(t, [{
      key: "onClick",
      value: function value(e, t, o) {
        this.props.onClick instanceof Function && this.props.onClick(e, t, o);
      }
    }, {
      key: "onContextMenu",
      value: function value(e, t, o) {
        o.preventDefault(), this.props.onContextMenu instanceof Function && this.props.onContextMenu(e, t, o);
      }
    }, {
      key: "onAvatarError",
      value: function value(e, t, o) {
        this.props.onAvatarError instanceof Function && this.props.onAvatarError(e, t, o);
      }
    }, {
      key: "render",
      value: function value() {
        var e = this;
        return s.default.createElement("div", {
          ref: this.props.cmpRef,
          className: c("rce-container-clist", this.props.className),
          __source: {
            fileName: n,
            lineNumber: 28
          }
        }, this.props.dataSource.map(function (t, o) {
          return s.default.createElement(l.default, r({
            id: t.id || o,
            key: o,
            lazyLoadingImage: e.props.lazyLoadingImage
          }, t, {
            onAvatarError: function onAvatarError(r) {
              return e.onAvatarError(t, o, r);
            },
            onContextMenu: function onContextMenu(r) {
              return e.onContextMenu(t, o, r);
            },
            onClick: function onClick() {
              return e.onClick(t, o);
            },
            __source: {
              fileName: n,
              lineNumber: 33
            }
          }));
        }));
      }
    }]), t;
  }();

  p.defaultProps = {
    dataSource: [],
    onClick: null,
    lazyLoadingImage: void 0
  }, t.default = p;
}, function (e, t, o) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.MessageList = void 0;

  var r = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var o = arguments[t];

      for (var r in o) {
        Object.prototype.hasOwnProperty.call(o, r) && (e[r] = o[r]);
      }
    }

    return e;
  },
      n = "/Users/burak/github/react-chat-elements/src/MessageList/MessageList.js",
      a = function () {
    function e(e, t) {
      for (var o = 0; o < t.length; o++) {
        var r = t[o];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    return function (t, o, r) {
      return o && e(t.prototype, o), r && e(t, r), t;
    };
  }(),
      i = o(0),
      s = c(i);

  o(54);
  var l = c(o(4)),
      u = c(o(25));

  function c(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  var p = o(1),
      f = t.MessageList = function (e) {
    function t(e) {
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t);

      var o = function (e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e));

      return o.state = {
        scrollBottom: 0,
        downButton: !1
      }, o.loadRef = o.loadRef.bind(o), o.onScroll = o.onScroll.bind(o), o;
    }

    return function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }(t, i.Component), a(t, [{
      key: "checkScroll",
      value: function value() {
        var e = this.mlistRef;
        e && ("100%" === this.props.toBottomHeight || this.state.scrollBottom < this.props.toBottomHeight ? e.scrollTop = e.scrollHeight : !0 === this.props.lockable && (e.scrollTop = e.scrollHeight - e.offsetHeight - this.state.scrollBottom));
      }
    }, {
      key: "componentWillReceiveProps",
      value: function value(e) {
        this.mlistRef && e.dataSource.length !== this.props.dataSource.length && this.setState({
          scrollBottom: this.getBottom(this.mlistRef)
        }, this.checkScroll.bind(this));
      }
    }, {
      key: "getBottom",
      value: function value(e) {
        return e.scrollHeight - e.scrollTop - e.offsetHeight;
      }
    }, {
      key: "onOpen",
      value: function value(e, t, o) {
        this.props.onOpen instanceof Function && this.props.onOpen(e, t, o);
      }
    }, {
      key: "onDownload",
      value: function value(e, t, o) {
        this.props.onDownload instanceof Function && this.props.onDownload(e, t, o);
      }
    }, {
      key: "onPhotoError",
      value: function value(e, t, o) {
        this.props.onPhotoError instanceof Function && this.props.onPhotoError(e, t, o);
      }
    }, {
      key: "onClick",
      value: function value(e, t, o) {
        this.props.onClick instanceof Function && this.props.onClick(e, t, o);
      }
    }, {
      key: "onTitleClick",
      value: function value(e, t, o) {
        this.props.onTitleClick instanceof Function && this.props.onTitleClick(e, t, o);
      }
    }, {
      key: "onForwardClick",
      value: function value(e, t, o) {
        this.props.onForwardClick instanceof Function && this.props.onForwardClick(e, t, o);
      }
    }, {
      key: "onReplyClick",
      value: function value(e, t, o) {
        this.props.onReplyClick instanceof Function && this.props.onReplyClick(e, t, o);
      }
    }, {
      key: "onReplyMessageClick",
      value: function value(e, t, o) {
        this.props.onReplyMessageClick instanceof Function && this.props.onReplyMessageClick(e, t, o);
      }
    }, {
      key: "onContextMenu",
      value: function value(e, t, o) {
        this.props.onContextMenu instanceof Function && this.props.onContextMenu(e, t, o);
      }
    }, {
      key: "onMessageFocused",
      value: function value(e, t, o) {
        this.props.onMessageFocused instanceof Function && this.props.onMessageFocused(e, t, o);
      }
    }, {
      key: "loadRef",
      value: function value(e) {
        this.mlistRef = e, this.props.cmpRef instanceof Function && this.props.cmpRef(e);
      }
    }, {
      key: "onScroll",
      value: function value(e) {
        var t = this.getBottom(e.target);
        this.state.scrollBottom = t, "100%" === this.props.toBottomHeight || t > this.props.toBottomHeight ? !0 !== this.state.downButton && (this.state.downButton = !0, this.setState({
          downButton: !0,
          scrollBottom: t
        })) : !1 !== this.state.downButton && (this.state.downButton = !1, this.setState({
          downButton: !1,
          scrollBottom: t
        })), this.props.onScroll instanceof Function && this.props.onScroll(e);
      }
    }, {
      key: "toBottom",
      value: function value(e) {
        this.mlistRef && (this.mlistRef.scrollTop = this.mlistRef.scrollHeight, this.props.onDownButtonClick instanceof Function && this.props.onDownButtonClick(e));
      }
    }, {
      key: "render",
      value: function value() {
        var e = this;
        return s.default.createElement("div", {
          className: p(["rce-container-mlist", this.props.className]),
          __source: {
            fileName: n,
            lineNumber: 145
          }
        }, s.default.createElement("div", {
          ref: this.loadRef,
          onScroll: this.onScroll,
          className: "rce-mlist",
          __source: {
            fileName: n,
            lineNumber: 147
          }
        }, this.props.dataSource.map(function (t, o) {
          return s.default.createElement(l.default, r({
            key: o
          }, t, {
            onOpen: e.props.onOpen && function (r) {
              return e.onOpen(t, o, r);
            },
            onPhotoError: e.props.onPhotoError && function (r) {
              return e.onPhotoError(t, o, r);
            },
            onDownload: e.props.onDownload && function (r) {
              return e.onDownload(t, o, r);
            },
            onTitleClick: e.props.onTitleClick && function (r) {
              return e.onTitleClick(t, o, r);
            },
            onForwardClick: e.props.onForwardClick && function (r) {
              return e.onForwardClick(t, o, r);
            },
            onReplyClick: e.props.onReplyClick && function (r) {
              return e.onReplyClick(t, o, r);
            },
            onReplyMessageClick: e.props.onReplyMessageClick && function (r) {
              return e.onReplyMessageClick(t, o, r);
            },
            onClick: e.props.onClick && function (r) {
              return e.onClick(t, o, r);
            },
            onContextMenu: e.props.onContextMenu && function (r) {
              return e.onContextMenu(t, o, r);
            },
            onMessageFocused: e.props.onMessageFocused && function (r) {
              return e.onMessageFocused(t, o, r);
            },
            __source: {
              fileName: n,
              lineNumber: 153
            }
          }));
        })), !0 === this.props.downButton && this.state.downButton && "100%" !== this.props.toBottomHeight && s.default.createElement("div", {
          className: "rce-mlist-down-button",
          onClick: this.toBottom.bind(this),
          __source: {
            fileName: n,
            lineNumber: 174
          }
        }, s.default.createElement(u.default, {
          __source: {
            fileName: n,
            lineNumber: 177
          }
        }), this.props.downButtonBadge && s.default.createElement("span", {
          className: "rce-mlist-down-button--badge",
          __source: {
            fileName: n,
            lineNumber: 180
          }
        }, this.props.downButtonBadge)));
      }
    }]), t;
  }();

  f.defaultProps = {
    onClick: null,
    onTitleClick: null,
    onForwardClick: null,
    onReplyClick: null,
    onReplyMessageClick: null,
    onDownButtonClick: null,
    onOpen: null,
    onPhotoError: null,
    onDownload: null,
    dataSource: [],
    lockable: !1,
    toBottomHeight: 300,
    downButton: !0,
    downButtonBadge: null
  }, t.default = f;
}, function (e, t) {
  e.exports = require("react-icons/lib/fa/chevron-down");
}, function (e, t, o) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.Input = void 0;

  var r = "/Users/burak/github/react-chat-elements/src/Input/Input.js",
      n = function () {
    function e(e, t) {
      for (var o = 0; o < t.length; o++) {
        var r = t[o];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    return function (t, o, r) {
      return o && e(t.prototype, o), r && e(t, r), t;
    };
  }(),
      a = o(0),
      i = function (e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }(a);

  o(56);

  var s = o(1),
      l = t.Input = function (e) {
    function t(e) {
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t);

      var o = function (e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e));

      return o.state = {
        value: o.props.defaultValue
      }, o;
    }

    return function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }(t, a.Component), n(t, [{
      key: "onChange",
      value: function value(e) {
        this.props.maxlength && (e.target.value || "").length > this.props.maxlength ? this.props.onMaxLengthExceed instanceof Function && this.props.onMaxLengthExceed() : (this.setState({
          value: e.target.value
        }), this.props.onChange instanceof Function && this.props.onChange(e), !0 === this.props.multiline && !0 === this.props.autoHeight && (e.target.style.height = this.props.minHeight + "px", e.target.scrollHeight <= this.props.maxHeight ? e.target.style.height = e.target.scrollHeight + "px" : e.target.style.height = this.props.maxHeight + "px"));
      }
    }, {
      key: "clear",
      value: function value() {
        var e = {
          FAKE_EVENT: !0,
          target: this.input
        };
        this.input.value = "", this.onChange(e);
      }
    }, {
      key: "componentDidMount",
      value: function value() {
        !0 === this.props.autofocus && this.input.focus();
      }
    }, {
      key: "render",
      value: function value() {
        var e = this;
        return i.default.createElement("div", {
          className: s("rce-container-input", this.props.className),
          __source: {
            fileName: r,
            lineNumber: 56
          }
        }, this.props.leftButtons && i.default.createElement("div", {
          className: "rce-input-buttons",
          __source: {
            fileName: r,
            lineNumber: 59
          }
        }, this.props.leftButtons), !1 === this.props.multiline ? i.default.createElement("input", {
          ref: function ref(t) {
            e.props.inputRef instanceof Function && e.props.inputRef(t), e.input = t;
          },
          type: this.props.type,
          className: s("rce-input"),
          placeholder: this.props.placeholder,
          value: this.state.value,
          style: this.props.inputStyle,
          onChange: this.onChange.bind(this),
          onCopy: this.props.onCopy,
          onCut: this.props.onCut,
          onPaste: this.props.onPaste,
          onBlur: this.props.onBlur,
          onFocus: this.props.onFocus,
          onSelect: this.props.onSelect,
          onSubmit: this.props.onSubmit,
          onReset: this.props.onReset,
          onKeyDown: this.props.onKeyDown,
          onKeyPress: this.props.onKeyPress,
          onKeyUp: this.props.onKeyUp,
          __source: {
            fileName: r,
            lineNumber: 65
          }
        }) : i.default.createElement("textarea", {
          ref: function ref(t) {
            e.props.inputRef instanceof Function && e.props.inputRef(t), e.input = t;
          },
          type: this.props.type,
          className: s("rce-input", "rce-input-textarea"),
          placeholder: this.props.placeholder,
          value: this.state.value,
          style: this.props.inputStyle,
          onChange: this.onChange.bind(this),
          onCopy: this.props.onCopy,
          onCut: this.props.onCut,
          onPaste: this.props.onPaste,
          onBlur: this.props.onBlur,
          onFocus: this.props.onFocus,
          onSelect: this.props.onSelect,
          onSubmit: this.props.onSubmit,
          onReset: this.props.onReset,
          onKeyDown: this.props.onKeyDown,
          onKeyPress: this.props.onKeyPress,
          onKeyUp: this.props.onKeyUp,
          __source: {
            fileName: r,
            lineNumber: 89
          }
        }), this.props.rightButtons && i.default.createElement("div", {
          className: "rce-input-buttons",
          __source: {
            fileName: r,
            lineNumber: 115
          }
        }, this.props.rightButtons));
      }
    }]), t;
  }();

  l.defaultProps = {
    type: "text",
    placeholder: "",
    defaultValue: "",
    onChange: null,
    rightButtons: null,
    leftButtons: null,
    multiline: !1,
    minHeight: 25,
    maxHeight: 200,
    autoHeight: !0,
    inputStyle: null,
    inputRef: null,
    maxlength: null,
    onMaxLengthExceed: null,
    autofocus: !1
  }, t.default = l;
}, function (e, t, o) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.Navbar = void 0;

  var r = "/Users/burak/github/react-chat-elements/src/Navbar/Navbar.js",
      n = function () {
    function e(e, t) {
      for (var o = 0; o < t.length; o++) {
        var r = t[o];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    return function (t, o, r) {
      return o && e(t.prototype, o), r && e(t, r), t;
    };
  }(),
      a = o(0),
      i = function (e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }(a);

  o(60);

  var s = o(1),
      l = t.Navbar = function (e) {
    function t() {
      return function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t), function (e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
    }

    return function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }(t, a.Component), n(t, [{
      key: "render",
      value: function value() {
        return i.default.createElement("div", {
          className: s("rce-navbar", this.props.type, this.props.className),
          __source: {
            fileName: r,
            lineNumber: 9
          }
        }, i.default.createElement("div", {
          className: "rce-navbar-item rce-navbar-item__left",
          __source: {
            fileName: r,
            lineNumber: 10
          }
        }, this.props.left), i.default.createElement("div", {
          className: "rce-navbar-item rce-navbar-item__center",
          __source: {
            fileName: r,
            lineNumber: 13
          }
        }, this.props.center), i.default.createElement("div", {
          className: "rce-navbar-item rce-navbar-item__right",
          __source: {
            fileName: r,
            lineNumber: 16
          }
        }, this.props.right));
      }
    }]), t;
  }();

  l.defaultProps = {
    left: null,
    center: null,
    right: null,
    type: "light"
  }, t.default = l;
}, function (e, t, o) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.Dropdown = void 0;

  var r = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var o = arguments[t];

      for (var r in o) {
        Object.prototype.hasOwnProperty.call(o, r) && (e[r] = o[r]);
      }
    }

    return e;
  },
      n = "/Users/burak/github/react-chat-elements/src/Dropdown/Dropdown.js",
      a = function () {
    function e(e, t) {
      for (var o = 0; o < t.length; o++) {
        var r = t[o];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    return function (t, o, r) {
      return o && e(t.prototype, o), r && e(t, r), t;
    };
  }(),
      i = o(0),
      s = u(i);

  o(62);
  var l = u(o(3));

  function u(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  var c = o(1),
      p = t.Dropdown = function (e) {
    function t(e) {
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t);

      var o = function (e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e));

      return o.state = {
        show: void 0
      }, o;
    }

    return function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }(t, i.Component), a(t, [{
      key: "onBlur",
      value: function value(e) {
        !0 === this.state.show && this.setState({
          show: !1
        });
      }
    }, {
      key: "render",
      value: function value() {
        var e = this;
        return s.default.createElement("div", {
          className: c("rce-dropdown-container", this.props.className),
          onBlur: this.onBlur.bind(this),
          __source: {
            fileName: n,
            lineNumber: 24
          }
        }, s.default.createElement(l.default, r({}, this.props.buttonProps, {
          onClick: function onClick() {
            return e.setState({
              show: !e.state.show
            });
          },
          __source: {
            fileName: n,
            lineNumber: 26
          }
        })), s.default.createElement("div", {
          className: c("rce-dropdown", this.props.animationType, "rce-dropdown-open__" + this.props.animationPosition, {
            "dropdown-hide": !1 === this.state.show
          }, {
            "dropdown-show": !0 === this.state.show
          }),
          __source: {
            fileName: n,
            lineNumber: 30
          }
        }, s.default.createElement("ul", {
          __source: {
            fileName: n,
            lineNumber: 38
          }
        }, this.props.title && s.default.createElement("span", {
          className: "rce-dropdown-title",
          __source: {
            fileName: n,
            lineNumber: 41
          }
        }, this.props.title), this.props.items.map(function (t, o) {
          return s.default.createElement("li", {
            key: o,
            onMouseDown: function onMouseDown(t) {
              return e.props.onSelect(o);
            },
            __source: {
              fileName: n,
              lineNumber: 45
            }
          }, t instanceof Object ? t.icon ? s.default.createElement("span", {
            className: "rce-button-icon--container",
            __source: {
              fileName: n,
              lineNumber: 49
            }
          }, ("right" === t.icon.float || !t.icon.float) && s.default.createElement("a", {
            __source: {
              fileName: n,
              lineNumber: 50
            }
          }, t.text), s.default.createElement("span", {
            style: {
              float: t.icon.float,
              color: t.icon.color,
              fontSize: t.icon.size || 12
            },
            className: c("rce-button-icon", t.icon.className),
            __source: {
              fileName: n,
              lineNumber: 52
            }
          }, t.icon.component), "left" === t.icon.float && s.default.createElement("a", {
            __source: {
              fileName: n,
              lineNumber: 54
            }
          }, t.text)) : s.default.createElement("a", {
            __source: {
              fileName: n,
              lineNumber: 56
            }
          }, t.text) : s.default.createElement("a", {
            __source: {
              fileName: n,
              lineNumber: 58
            }
          }, t));
        }))));
      }
    }]), t;
  }();

  p.defaultProps = {
    animationType: "default",
    animationPosition: "nortwest",
    items: [],
    onSelect: Function,
    buttonProps: null
  }, t.default = p;
}, function (e, t, o) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.SideBar = void 0;

  var r = "/Users/burak/github/react-chat-elements/src/SideBar/SideBar.js",
      n = function () {
    function e(e, t) {
      for (var o = 0; o < t.length; o++) {
        var r = t[o];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    return function (t, o, r) {
      return o && e(t.prototype, o), r && e(t, r), t;
    };
  }(),
      a = o(0),
      i = function (e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }(a);

  o(64);

  var s = o(1),
      l = t.SideBar = function (e) {
    function t() {
      return function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t), function (e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
    }

    return function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }(t, a.Component), n(t, [{
      key: "render",
      value: function value() {
        return i.default.createElement("div", {
          className: s("rce-sbar", this.props.type, this.props.className),
          __source: {
            fileName: r,
            lineNumber: 9
          }
        }, i.default.createElement("div", {
          className: "rce-sbar-item",
          __source: {
            fileName: r,
            lineNumber: 10
          }
        }, this.props.top), i.default.createElement("div", {
          className: "rce-sbar-item rce-sbar-item__center",
          __source: {
            fileName: r,
            lineNumber: 13
          }
        }, this.props.center), i.default.createElement("div", {
          className: "rce-sbar-item",
          __source: {
            fileName: r,
            lineNumber: 16
          }
        }, this.props.bottom));
      }
    }]), t;
  }();

  l.defaultProps = {
    top: null,
    center: null,
    bottom: null,
    type: "dark"
  }, t.default = l;
}, function (e, t, o) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.Popup = void 0;

  var r = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var o = arguments[t];

      for (var r in o) {
        Object.prototype.hasOwnProperty.call(o, r) && (e[r] = o[r]);
      }
    }

    return e;
  },
      n = "/Users/burak/github/react-chat-elements/src/Popup/Popup.js",
      a = function () {
    function e(e, t) {
      for (var o = 0; o < t.length; o++) {
        var r = t[o];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    return function (t, o, r) {
      return o && e(t.prototype, o), r && e(t, r), t;
    };
  }(),
      i = o(0),
      s = u(i);

  o(66);
  var l = u(o(3));

  function u(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  var c = o(1),
      p = t.Popup = function (e) {
    function t() {
      return function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t), function (e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
    }

    return function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }(t, i.Component), a(t, [{
      key: "render",
      value: function value() {
        return !0 === this.props.show ? s.default.createElement("div", {
          className: c("rce-popup-wrapper", this.props.type, this.props.className),
          __source: {
            fileName: n,
            lineNumber: 12
          }
        }, s.default.createElement("div", {
          className: "rce-popup",
          __source: {
            fileName: n,
            lineNumber: 13
          }
        }, this.props.renderHeader ? s.default.createElement("div", {
          className: "rce-popup-header",
          __source: {
            fileName: n,
            lineNumber: 16
          }
        }, this.props.renderHeader()) : s.default.createElement("div", {
          className: "rce-popup-header",
          __source: {
            fileName: n,
            lineNumber: 20
          }
        }, s.default.createElement("span", {
          __source: {
            fileName: n,
            lineNumber: 21
          }
        }, this.props.header), this.props.header && this.props.headerButtons.map(function (e, t) {
          return s.default.createElement(l.default, r({
            key: t
          }, e, {
            __source: {
              fileName: n,
              lineNumber: 25
            }
          }));
        })), s.default.createElement("div", {
          className: "rce-popup-content",
          style: {
            color: this.props.color
          },
          __source: {
            fileName: n,
            lineNumber: 32
          }
        }, this.props.renderContent ? this.props.renderContent() : this.props.text), s.default.createElement("div", {
          className: "rce-popup-footer",
          __source: {
            fileName: n,
            lineNumber: 40
          }
        }, this.props.renderFooter ? this.props.renderFooter() : this.props.footerButtons.map(function (e, t) {
          return s.default.createElement(l.default, r({
            key: t
          }, e, {
            __source: {
              fileName: n,
              lineNumber: 46
            }
          }));
        })))) : null;
      }
    }]), t;
  }();

  p.defaultProps = {
    show: !1,
    header: null,
    text: null,
    headerButtons: [],
    footerButtons: [],
    renderHeader: null,
    renderContent: null,
    renderFooter: null,
    color: "#333"
  }, t.default = p;
}, function (e, t) {},,,,, function (e, t) {},, function (e, t) {},, function (e, t) {},, function (e, t) {},, function (e, t) {},, function (e, t) {},, function (e, t) {},, function (e, t) {},, function (e, t) {},, function (e, t) {},, function (e, t) {},, function (e, t) {},, function (e, t) {},, function (e, t) {},, function (e, t) {},, function (e, t) {}]);